import { useState, useEffect } from 'react'
// react router
import { useParams } from 'react-router'
// redux
import { useSelector } from 'react-redux'
// formik
import { useFormik } from 'formik'
// schemas
import { editCitySchema } from '../../../schemes/city/editCitySchema'
// componetns
import {
    PageTitle,
    MainButton,
    ErrorMessage,
    RingsLoader,
} from '../../../components'
// axios
import enhancedAxios from '../../../utils/axiosUtils/enhancedAxios'
// mui
import { Stack, TextField, FormControlLabel, Checkbox } from '@mui/material'
// alerts
import { errorAlert, successAlert } from '../../../utils/alerts'

const EditCity = () => {
    const [isLoading, setIsLoading] = useState(true)
    const userToken = useSelector((state) => state.userToken)
    const { id } = useParams()
    const onSubmit = (values) => {
        const formData = new FormData()
        for (let i in values) {
            formData.append(i, values[i])
        }

        enhancedAxios('multipart/form-data', userToken)
            .put(`/admin/cities/${id}`, formData)
            .then((response) => {
                successAlert('تم تعديل المدينة')
                setSubmitting(false)
            })
            .catch((error) => errorAlert(error))
    }
    // formik configration
    const {
        values,
        setValues,
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        isSubmitting,
        setSubmitting,
        resetForm,
    } = useFormik({
        initialValues: {
            name: '',
            is_disabled: false,
        },
        validationSchema: editCitySchema,
        onSubmit, //function we write above
    })
    //get current city data
    useEffect(() => {
        setIsLoading(true)
        enhancedAxios(null, userToken)
            .get(`/admin/cities/${id}`)
            .then((response) => {
                setValues({
                    ...values,
                    name: response.data.name,
                    is_disabled: response.data.is_disabled,
                })
                setIsLoading(false)
            })
    }, [id])

    if (isLoading) {
        return <RingsLoader />
    }
    return (
        <Stack width="100%" height="100%" spacing={8} alignItems="center">
            <PageTitle title="تعديل  المدينة" />
            {/* ---------------------------------- form --------------------------------  */}
            <Stack
                component="form"
                spacing={2}
                onSubmit={handleSubmit}
                width="100%"
                maxWidth="600px"
            >
                <TextField
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="اسم المدينة"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={values.is_disabled}
                            onChange={handleChange}
                            name="is_disabled"
                        />
                    }
                    label="اخفاء المدينة"
                />
                {/* submit button */}
                <MainButton text="تعديل" disabled={isSubmitting} />
                {errors && (
                    <Stack spacing={1}>
                        {errors.name && touched.name && (
                            <ErrorMessage errorMsg={errors.name} />
                        )}
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}

export default EditCity
